import { SourceTypes } from '../../../datasource-form';

export const FRONT_SOURCE_TYPES = [SourceTypes.Api, SourceTypes.Local];
export const BACK_SOURCE_TYPES = [SourceTypes.Jdbc];
